import Template from "../../layout/Template";
import ClienteCadEdit from "./ClienteCadEdit";




const ClienteCadastro=()=>{

    return(
        <>

            <ClienteCadEdit cadastrar={true}/>
        
        </>

    );
}
export default ClienteCadastro